module.exports = "/_next/static/images/OrchestrateTheOutcomes@2x-2073a893f701a52e6fe4b01ad3dca76d.png";